import { render, staticRenderFns } from "./CandleSad.vue?vue&type=template&id=d1e5defc&scoped=true&"
var script = {}
import style0 from "./CandleSad.vue?vue&type=style&index=0&id=d1e5defc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e5defc",
  null
  
)

export default component.exports